import React from 'react'
import './ImpactStore.css'
import Button from '../button/Button'
import { images } from '../../assets'

function ImpactStore({onButtonClick, buttonText, className}) {
  return (
    <div className='impactStore'>
        <div className='impactStoreBox'>
            <div className='impactStoreContent'>
                <div className='impactStoreText'>
                    <div className='storeTitle'>Promote Your Products</div>
                    <div className='storeDescription'>
                    With the Store, we bring the concept of ‘rewarding people for their good deeds’ to life. Every healthy habit, every good karma that lakhs of our users gets rewarded by the best, most caring brands of the country. Want to join?
                    </div>
                </div>

                <Button onClick={onButtonClick} buttonText={buttonText} className={className.customButton} arrowClassName="custom-arrow" />

            </div>
            <div className='impactStorePhoto'>
                <img src={images.impactStore} alt="Impact Store" />
            </div>
        </div> 
    </div>
  )
}

export default ImpactStore
